if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector("form")
        this.form.querySelector("[name=id]").disabled = false
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this))
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")
        this.submitButton = this.querySelector('[type="submit"]')
      }

      /* 
      * ========================================
      * INTEGRACION DE PRODUCTOS PERSONALIZABLES 
      * ========================================
      */
      buildBundleFormData(formData, variantId = null) {

        const bundleId = Date.now() + '-' + Math.random().toString(36).substr(2,5);

        const mainVariantId = variantId || formData.get('id');

        const flecosChecks = document.querySelectorAll('[name^="properties[Flecos]"]:checked');
        const initialsInput = document.querySelector('#initials-input');
        const selectedColorEl = document.querySelector('.initials-option.active');
        const selectedColor = selectedColorEl ? selectedColorEl.dataset.label : 'Rojo';
        const disenoChecked = document.querySelector('input[name="personalizacion-diseno"]:checked');
        const disenoColorEl = document.querySelector('.diseno-color-option.active');
        const disenoColor = disenoColorEl ? disenoColorEl.dataset.label : 'Blanco';
        const disenoPositionEl = document.querySelector('.diseno-position-option.active');
        const disenoPosition = disenoPositionEl ? disenoPositionEl.dataset.label : 'Cintura';

        let initialsValue = '';
        let hasFlecos = flecosChecks.length > 0;
        let hasInitials = false;
        let hasDiseno = !!disenoChecked;

        if (initialsInput) {
          initialsValue = initialsInput.value.trim();
          if (initialsValue.length > 0) hasInitials = true;
        }

        // console.log('Bundle DEBUG', { initialsValue, hasFlecos, hasInitials });

        if (!hasFlecos && !hasInitials && !hasDiseno) {
          return formData; // 👈 comportamiento normal
        }

        formData.delete('id');

        let itemIndex = 0;

        // MAIN PRODUCT
        formData.append(`items[${itemIndex}][id]`, mainVariantId);
        formData.append(`items[${itemIndex}][quantity]`, 1);
        formData.append(`items[${itemIndex}][properties][_bundle]`, bundleId);

        // FLECOS
        if (hasFlecos) {

          let flecosLabels = [];
          let totalPrice = 0;

          flecosChecks.forEach((checkbox) => {

            const addonId = checkbox.dataset.addonVariant;
            const label   = checkbox.value;
            const price   = parseFloat(checkbox.dataset.addonPrice || 0);

            if (!addonId) return;

            flecosLabels.push(label);
            totalPrice += price;

            itemIndex++;

            formData.append(`items[${itemIndex}][id]`, addonId);
            formData.append(`items[${itemIndex}][quantity]`, 1);
            formData.append(`items[${itemIndex}][properties][_bundle]`, bundleId);
            formData.append(`items[${itemIndex}][properties][_addon]`, '1');
          });

          formData.append(
            'items[0][properties][Flecos]',
            flecosLabels.join(' + ') + ' (+' + Math.round(totalPrice) + '€)'
          );
        }

        // INICIALES
        if (hasInitials) {

          const addonId = initialsInput.dataset.addonVariant;
          const price   = parseFloat(initialsInput.dataset.addonPrice || 0);

          if (addonId) {

            itemIndex++;

            formData.append(`items[${itemIndex}][id]`, addonId);
            formData.append(`items[${itemIndex}][quantity]`, 1);
            formData.append(`items[${itemIndex}][properties][_bundle]`, bundleId);
            formData.append(`items[${itemIndex}][properties][_addon]`, '1');

            // formData.append(
            //   'items[0][properties][Iniciales]',
            //   initialsValue + ' - ' + selectedColor + ' (+' + Math.round(price) + '€)'
            // );

            formData.append(
              'items[0][properties][Iniciales]',
              initialsValue + ' (+4,50€)'
            );

            formData.append(
              'items[0][properties][Color_Iniciales]',
              selectedColor
            );
          }
        }

        // DISEÑO BORDADO (gratuito: sin producto addon, solo propiedades)
        if (hasDiseno) {

          formData.append(
            'items[0][properties][Diseño_Bordado]',
            disenoChecked.value
          );

          formData.append(
            'items[0][properties][Color_Bordado]',
            disenoColor
          );

          formData.append(
            'items[0][properties][Posicion_Bordado]',
            disenoPosition
          );
        }

        return formData;
      }
      /* 
      * ============================================ 
      * FIN INTEGRACION DE PRODUCTOS PERSONALIZABLES 
      * ============================================
      */

      onSubmitHandler(evt) {
        evt.preventDefault()

        let classes = evt.target.classList.value

        this.small = window.matchMedia("(max-width: 749px)")
        this.mql = window.matchMedia("(min-width: 990px)")

        if (this.small.matches && classes.includes("js-submit-choose")) {
          document.querySelector("form.js-submit-choose").classList.remove("js-submit-choose")
        }
        if (classes.includes("js-submit-choose")) {
          document.querySelector(".product-form__radios.size-radios").classList.add("open")
          document.querySelector(".product-form__radios.size-radios").previousElementSibling.classList.add("open")
          if (document.querySelector(".product-form__radios.size-radios input:checked")) {
            document.querySelector(".product-form__radios.size-radios input:checked").checked = false
          }
        } else {
          if (this.submitButton.getAttribute("aria-disabled") === "true") return

          this.handleErrorMessage()

          this.submitButton.setAttribute("aria-disabled", true)
          this.submitButton.classList.add("loading")
          this.querySelector(".loading-overlay__spinner").classList.remove("hidden")

          const config = fetchConfig("javascript")
          config.headers["X-Requested-With"] = "XMLHttpRequest"
          delete config.headers["Content-Type"]

          // const formData = new FormData(this.form)
          let formData = new FormData(this.form)
          formData = this.buildBundleFormData(formData)

          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            )
            formData.append("sections_url", window.location.pathname)
            this.cart.setActiveElement(document.activeElement)
          }
          config.body = formData

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description)

                const soldOutMessage = this.submitButton.querySelector(".sold-out-message")
                if (!soldOutMessage) return
                this.submitButton.setAttribute("aria-disabled", true)
                this.submitButton.querySelector("span.desktop-submit").classList.add("hidden")
                soldOutMessage.classList.remove("hidden")
                this.error = true
                return
              } else if (!this.cart) {
                window.location = window.routes.cart_url
                return
              }

              this.error = false
              const quickAddModal = this.closest("quick-add-modal")
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response)
                    })
                  },
                  { once: true }
                )
                quickAddModal.hide(true)
              } else {
                this.cart.renderContents(response)
              }
            })
            .catch((e) => {
              console.error(e)
            })
            .finally(() => {
              this.submitButton.classList.remove("loading")
              if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty")
              if (!this.error) this.submitButton.removeAttribute("aria-disabled")
              this.querySelector(".loading-overlay__spinner").classList.add("hidden")
              if (this.mql.matches) {
                this.form.classList.remove("js-submit-choose")
              } else {
                if (!this.form.classList.contains("product-form-bundle")) {
                  this.form.classList.add("js-submit-choose")
                }
              }
            })
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")
        if (!this.errorMessageWrapper) return
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }

      
    }
  )
}


/* 
* =====================================================================
* PRODUCTOS PERSONALIZABLES - INICIALES - EVITAR SUBMIT NORMAL EN MÓVIL
* =====================================================================
*/
document.addEventListener('click', async function(e) {

  const btn = e.target.closest('.mobile-size-btn');
  if (!btn) return;

  // console.log('📱 Mobile add to cart (interceptado limpio)');

  const modal = document.querySelector('#PopupModal-Sizes');
  if (modal && modal.hide) {
    modal.hide();
  }

  const variantId = btn.dataset.variantId;
  const isAvailable = btn.dataset.available === 'true';

  if (!variantId || !isAvailable) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const productFormEl = document.querySelector('product-form');
  if (!productFormEl) return;

  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];

  let formData = new FormData();

  formData = productFormEl.buildBundleFormData(formData, variantId);

  if (!formData.has('items[0][id]')) {
    // 👉 fallback normal
    formData.append('id', variantId);
    formData.append('quantity', 1);
  }

  const cart = document.querySelector("cart-drawer");

  if (cart) {
    formData.append(
      "sections",
      cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append("sections_url", window.location.pathname);
  }

  config.body = formData;

  const res = await fetch(`${routes.cart_add_url}`, config);
  const data = await res.json();

  if (cart) cart.renderContents(data);
  

}, true);